import { render, staticRenderFns } from "./VinTransactionHistory.vue?vue&type=template&id=2a459b10"
import script from "./VinTransactionHistory.vue?vue&type=script&lang=js"
export * from "./VinTransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports